import { ThrownError } from './InnerStore';
export function createStoreCache(getThrownError) {
    var namespaceCaches = {};
    var namespaceStates = {};
    var registeredConfigs = {};
    var registeredGetStates = {};
    var register = function (namespace, getState, config) {
        registeredConfigs[namespace] = config;
        registeredGetStates[namespace] = getState;
    };
    var get = function (namespace) {
        var state = registeredGetStates[namespace]();
        if (state === undefined || state !== namespaceStates[namespace]) {
            namespaceStates[namespace] = state;
            namespaceCaches[namespace] = compute(state, registeredConfigs[namespace], getThrownError);
        }
        return namespaceCaches[namespace];
    };
    var getMany = function (namespaces) {
        namespaces.forEach(get);
        return namespaceCaches;
    };
    return {
        get: get,
        getMany: getMany,
        register: register,
    };
}
function compute(state, config, getThrownError) {
    var hasThrownError = state === ThrownError;
    var error = hasThrownError ? getThrownError() : config.selectError(state);
    var hasCurrentValue = error !== undefined || config.selectHasValue(state);
    var value = error === undefined && hasCurrentValue
        ? config.selectValue(state)
        : undefined;
    return {
        error: error,
        hasCurrentValue: hasCurrentValue,
        value: value,
    };
}
//# sourceMappingURL=StoreCache.js.map